import { START_MATCH_DELIMITER, END_MATCH_DELIMITER, } from 'owa-mail-search-store/lib/helpers/searchConstants';
var SPACE_REGEX = /\s/g;
var NONBREAKING_SPACE_CHAR = String.fromCharCode(160);
var START_MATCH_DELIMITER_REGEXP = new RegExp(START_MATCH_DELIMITER, 'g');
var END_MATCH_DELIMITER_REGEXP = new RegExp(END_MATCH_DELIMITER, 'g');
export default function highlightDisplayText(displayText) {
    // Split the string into substrings that have exactly one highlighted area
    var highlightSubstrings = displayText
        .replace(SPACE_REGEX, NONBREAKING_SPACE_CHAR)
        .split(START_MATCH_DELIMITER);
    // Build an array of highlighted and unhighlighted regions
    var highlightTextRegions = highlightSubstrings.reduce(function (arr, current) {
        return arr.concat(
        // Split the current substring into a highlighted region and an unhighlighted region
        current.split(END_MATCH_DELIMITER).map(function (substr, i, subArr) {
            return {
                // if there are two sections, then the first one came before
                // the highlight end mark, and the second came after. If there
                // is only one section, then there was no highlighting to begin with.
                isHighlighted: i == 0 && subArr.length == 2,
                text: substr,
            };
        }));
    }, []);
    return highlightTextRegions;
}
export function dehighlightDisplayText(displayText) {
    return displayText
        .replace(START_MATCH_DELIMITER_REGEXP, '')
        .replace(END_MATCH_DELIMITER_REGEXP, '');
}
//# sourceMappingURL=highlightDisplayText.js.map